module.exports = __webpack_public_path__ + "img/2.72de8653.jpg";